import { render, staticRenderFns } from "./PortadaLibroPage.vue?vue&type=template&id=b663712c"
import script from "./PortadaLibroPage.js?vue&type=script&lang=js&external"
export * from "./PortadaLibroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports